query PlatformEdit($id: ID!) {
  platform(id: $id) {
    id
    title
    slug
    description
    status
    host
    videoProvider
    mailerConfigId
    logo {
      id
    }
    favicon {
      id
    }
    gaId
    theme {
      palette {
        type
        primary
        secondary
        backgroundColor
      }
      typography {
        fontFamily
        headingFontFamily
      }
    }
    footer {
      title
      subtitle
      social {
        type
        link
      }
    }
    defaultRowSize
    googleSiteVerification
    privacyPolicyUrl
    termsOfServiceUrl
    refundPolicyUrl
    customTerms {
      label
      url
    }
    customHTML
    customHead
    clientFields {
      type
      name
      label
      required
      options {
        value
        label
      }
      multiple
      placeholder
      helperText
    }
    supportEmail
    showSupportEmail
    showTerms
    showCookieBanner
    acceptTermsOfServiceOnSignIn
    hideableHeader
    isLikesEnabled
    isFavoritesEnabled
    isFeaturedVideosEnabled
    isVideoChatEnabled
    isStreamChatEnabled
    features
    marketingMonthlyQuota
    marketingJourneyEntriesPerDay
    isLiveReactionsEnabled
    parallelPremiumViewLimit
    organizationId
    languageId
    language {
      id
      code
      title
    }
    assistant {
      enabled
      name
      avatar {
        id
      }
      notes
      model
      monthlyBudgetUsd
      dailyMessagesPerViewer
    }
  }
}
